import './App.css';

import { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { loadMore, search } from './actions';

import NotFound from './components/notFound';
import Post from './components/post';
import Pagination from './components/pagination';
import { sklonenie } from './config';

import iconClose from './assets/img/icon-close.svg';

const listFilters = [
  { title: 'Решения', value: "solution" },
  { title: 'Рынки', value: "market" },
  { title: 'Технологии', value: "technology" },
  { title: 'Проекты', value: window.location.host == 'localhost:3000' ? "cases" : "cases" },
  { title: 'Разработчикам', value: window.location.host == 'localhost:3000' ? "razrabotchikam" : "razrabotchikam" },
  // { title: 'Партнёрам', value: "partner" },
  { title: 'Мероприятия', value: window.location.host == 'localhost:3000' ? "events" : "events" },
  { title: 'Ресурсы', value: "resources" },
  { title: 'Events', value: "latest" },
]

function App() {

  const [searchValue, setSearchValue] = useState('');
  const [showSidebar, setShowSidebar] = useState(false);
  const [toggleFilterGroup, setToggleFilterGroup] = useState(false);

  const [filterValues, setFilterValues] = useState({
    search: '',
    filter: [],
    page: 1,
    posts_per_page: 10
  });

  const dispatch = useDispatch();

  const { data } = useSelector(state => state.search);
  const { max_num_pages, posts, found_posts } = data;
  const searchResultValue = data.search;

  const handlePage = (e, direction, page) => {
    e.preventDefault();

    let currentPage = filterValues.page;

    if(direction == 'next'){
      currentPage = currentPage + 1;
    } else if (direction == 'prev'){
      currentPage = currentPage - 1;
    } else {
      currentPage = page;
    }

    let currentFilter = {
      ...filterValues,
      page: currentPage
    };

    setFilterValues(currentFilter);
    
    dispatch(search(currentFilter));


  }

  const handleSubmit = (e) => {
    e && e.preventDefault();

    let currentFilter = {
      ...filterValues,
      page: 1
    };

    dispatch(search(currentFilter));

  }

  const handleReset = e => {
    e.preventDefault();

    let currentFilter = {
      ...filterValues,
      filter: []
    }

    document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);

    dispatch(search(currentFilter));

    setFilterValues(currentFilter);

  }

  const handleResetAll = e => {
    e.preventDefault();

    let currentFilter = {
      ...filterValues,
      search: '',
      filter: [],
      page: 1
    };

    let redirectUrl = "/search";

    if (window.location.host == "localhost:3001") {
      redirectUrl = '/';
    }

    window.history.pushState({}, document.title, redirectUrl);

    dispatch(search(currentFilter));
    setFilterValues(currentFilter);
    setSearchValue('');

    document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);

  }

  const handleFilter = ({ target }) => {

    let checkedsFilter = [],
        checkedItems = document.querySelectorAll('input[type=checkbox]:checked');

    if (checkedItems){
      checkedItems.forEach(item => {
        checkedsFilter.push(item.value);
      })
    }

    let currentFilter = {
      ...filterValues,
      filter: checkedsFilter,
      page: 1
    }
    
    setFilterValues(currentFilter);
    dispatch(search(currentFilter));
    
  }

  const handleLoadMore = e => {
    e.preventDefault();

    let currentFilter = {
      ...filterValues,
      page: filterValues.page + 1
    };
    
    dispatch(loadMore(currentFilter));
    setFilterValues(currentFilter);

  }

  const handleClearSearch = e => {
    e.preventDefault();

    let redirectUrl = "/search";

    if(window.location.host == "localhost:3001"){
      redirectUrl = '/';
    }

    window.history.pushState({}, document.title, redirectUrl);

    let currentFilter = {
      ...filterValues,
      search: '',
      page: 1
    }

    setSearchValue('');
    setFilterValues(currentFilter);
    dispatch(search(currentFilter));

  }

  const handleSearchValue = e => {

    setSearchValue(e.target.value);
    setFilterValues({
      ...filterValues,
      search: e.target.value
    })

    let redirectUrl = "/search";

    if (window.location.host == "localhost:3001") {
      redirectUrl = '/';
    }

    let searchValue = '';

    if (e.target.value.length){
      searchValue = '?search=' + e.target.value
    }

    window.history.pushState({}, document.title, redirectUrl + searchValue );

  }

  useEffect(() => {

    let searchParams = new URLSearchParams(window.location.search);
      
    handleSubmit();
    setSearchValue(searchParams.get('search') ? searchParams.get('search') : '');

  }, [])

  return (
    <div className="search">

      <form onSubmit={handleSubmit} className="search__form">
        <div className='search__form-input'>
          <input className='search__input' type="text" placeholder='Поиск...' onChange={handleSearchValue} value={searchValue} />
          {searchValue && searchValue.length > 0 && (
            <a href="#" className='search__input-clear' onClick={handleClearSearch}></a>
          )}
        </div>
        <div className='search__form-submit'>
          <button className='search__submit' type="submit">Найти</button>
        </div>
      </form>

      <div className='search__wrap'>
        <div className={`search__sidebar ${showSidebar ? '_active' : ''}`}>

          <div className='search__sidebar-header'>
            <div className='search__sidebar-title'>Фильтры</div>
            <a href="#" className='search__sidebar-close' onClick={e => {
              e.preventDefault();

              setShowSidebar(false);

            }}><img src={iconClose} /></a>
          </div>

          <div className='search__sidebar-wrap'>

            <div className={`search__filter-group ${toggleFilterGroup ? '_active' : ''}`}>
              <div className='search__filter-group-title' onClick={e => setToggleFilterGroup(!toggleFilterGroup)}>Тип материала</div>
              <div className='search__filter-group-list'>
                {listFilters && listFilters.map((item, index) => {
                  return (
                    <label key={index} className='search__filter'>
                      <input type="checkbox" className='search__filter-input' name="filter" onChange={handleFilter} value={item.value} />
                      <span className='search__filter-wrap'>{item.title}</span>
                    </label>
                  )
                })}
              </div>
            </div>

          </div>

          <div className='search__sidebar-reset'>

            {filterValues && filterValues.filter.length > 0 && (
              <a href="#" className='search__filter-reset' onClick={handleReset}><span></span>Сбросить</a>
            )}

            {/* {posts && !posts.length && (
              <a href="#" className='search__filter-reset-all' onClick={handleResetAll}><span></span>Сбросить всё</a>
            )} */}

          </div>

          <div className='search__sidebar-navbar'>

            <a href="#" className='search__filter-reset-all' onClick={handleResetAll}>Сбросить</a>
            
            <a href="#" className='search__filter-accept' onClick={e => {
              e.preventDefault();

              setShowSidebar(false);

            }}>Применить</a>

          </div>

        </div>

        <div className='search__navbar'>

          <button className='search__navbar-filter-button' onClick={e => setShowSidebar(true)}>Фильтр</button>
          <button className='search__navbar-filter-search' onClick={handleSubmit}>Найти</button>
        </div>

        <div className='search__content'>

          {posts && (
            <>

              {found_posts > 0 && <div className='search__result-count'>{found_posts} {sklonenie(found_posts, ['результат', 'результата', 'результатов'])} {searchResultValue && (<>«{searchResultValue}»</>)}</div>}

              {posts.length > 0 && (
                <div className='search__list'>
                  {posts.map((item, index) => {
                    return <Post key={item.id} {...item} />
                  })}
                </div>
              ) || (
                <NotFound />
              )}

              {filterValues.page < max_num_pages && (
                <div className='search__loadmore'>
                  <a href="#" className='search__loadmore-button' onClick={handleLoadMore}>Показать еще<span></span></a>
                </div>
              )}

              {max_num_pages > 1 && (
                <div className='search__pagination'>

                  <Pagination max_num_pages={max_num_pages} filterValues={filterValues} handlePage={handlePage} />

                </div>
              )}

            </>
          )}

        </div>
      </div>
    </div>
  );
}

export default App;
